import { FC } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell,
} from 'recharts';
import { ChartEmptyState } from '../../AthleteInjuryCharts/charts/_shared/ChartEmptyState';
import { ITeamSeverityMetric } from '../../../../models/injury';
import {
  chartAxisTick,
  chartGridProps,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: ITeamSeverityMetric | null;
}

// Gradiente di gravità sui soli token tema (nessun hex arbitrario): dal meno
// al più severo, success -> yellow -> warning -> error, ignoto = text-3.
const SEV_COLOR: Record<string, string> = {
  slight: 'var(--c-success)',
  minimal: 'var(--c-success)',
  mild: 'var(--c-yellow)',
  moderate: 'var(--c-warning)',
  severe: 'var(--c-error)',
  unknown: 'var(--c-text-3)',
};

const SEV_ORDER = ['slight', 'minimal', 'mild', 'moderate', 'severe', 'unknown'];

export const TeamSeverityChart: FC<Props> = ({ data }) => {
  if (!data?.data?.length) return <ChartEmptyState />;

  const chartData = [...data.data]
    .sort((a, b) => SEV_ORDER.indexOf(a.severity) - SEV_ORDER.indexOf(b.severity))
    .map((d) => ({ severity: d.severity, count: d.count, days: d.totalDaysLost }));

  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={chartData} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
        <CartesianGrid {...chartGridProps} />
        <XAxis dataKey="severity" tick={chartAxisTick} />
        <YAxis tick={chartAxisTick} allowDecimals={false} />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(v, _, props) => [`${v} inf. · ${props.payload.days} gg`, 'Infortuni']}
        />
        <Bar dataKey="count" radius={[4, 4, 0, 0]}>
          {chartData.map((d, i) => (
            <Cell key={i} fill={SEV_COLOR[d.severity] ?? 'var(--c-text-3)'} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
